import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Text } from '@lichtblick/photon/atoms/text/text';
import { useTracker } from '@lichtblick/tracker';
import { startTransition, useActionState, useCallback, useEffect, useRef } from 'react';
import { v4 as uuidV4 } from 'uuid';
import { FunnelSliderTrack } from '../components/funnel-slider-track/funnel-slider-track';
import { ReasonWhyTooltip } from '../components/reason-why-tooltip/reason-why-tooltip';
import { B2BAddressTooltipText } from './b2b-data-privacy-text';
import { headerContentMap, titleMap } from './b2b-funnel-embed.content';
import { useSuccessOrFailureHandling } from './b2b-funnel-embed.helpers';
import { createStartEvent, isSolarRequestType, useStepTracking } from './b2b-funnel-embed.tracking';
import { FunnelEmbedHeader } from './b2b-funnel-embed-header';
import styles from './funnel-embed.module.scss';
import { orderedStepComponents, stepProgresses } from './steps/all-steps';
import { submitForm } from './update-state';
const requestId = uuidV4();
const tooltipContentMap = {
    solarRequestType: 'Diese Information hilft uns, das passende Angebot für Ihre Bedürfnisse zu erstellen – ob Kauf, Contracting oder individuelle Beratung.',
    address: B2BAddressTooltipText,
    contactPerson: 'Wir benötigen Ihre Kontaktdaten, um Sie bei Rückfragen oder für Ihr Angebot direkt erreichen zu können.',
    email: 'Die E-Mail wird benötigt, um Sie zu erreichen, Ihnen Dokumente zu senden und weitere Schritte zu planen.'
};
export const InnerFunnelEmbed = ({ initialState, onStateChange })=>{
    const [state, dispatch, isPending] = useActionState(submitForm, initialState ?? {
        citiesAndStreets: [],
        currentStep: 'solarRequestType',
        formValues: {},
        requestId,
        stepHistory: []
    });
    useEffect(()=>onStateChange?.(state), [
        onStateChange,
        state
    ]);
    useStepTracking(state);
    useSuccessOrFailureHandling(state);
    const { trackCustomEvent } = useTracker();
    const Current = orderedStepComponents[state.currentStep];
    const Transitioning = state.transitioningStep ? orderedStepComponents[state.transitioningStep] : null;
    const onSubmit = useCallback((formData)=>{
        if (state.currentStep === 'solarRequestType') {
            const solarRequestType = formData.get('solarRequestType');
            if (isSolarRequestType(solarRequestType)) {
                trackCustomEvent(createStartEvent(solarRequestType));
            }
        }
        dispatch({
            formData
        });
    }, [
        dispatch,
        state.currentStep,
        trackCustomEvent
    ]);
    const formRef = useRef(null);
    return /*#__PURE__*/ _jsx("div", {
        className: styles.root,
        id: "anlage-berechnen",
        children: /*#__PURE__*/ _jsxs("form", {
            action: onSubmit,
            className: styles['funnel-card'],
            ref: formRef,
            children: [
                /*#__PURE__*/ _jsx(FunnelEmbedHeader, {
                    progressInPercent: stepProgresses[state.currentStep],
                    title: headerContentMap[state.currentStep]
                }),
                /*#__PURE__*/ _jsx(FunnelSliderTrack, {
                    current: /*#__PURE__*/ _jsxs("div", {
                        className: styles['funnel-embed-step'],
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                className: styles.headline,
                                size: "l",
                                children: titleMap[state.currentStep]
                            }),
                            tooltipContentMap[state.currentStep] && /*#__PURE__*/ _jsx(ReasonWhyTooltip, {
                                content: tooltipContentMap[state.currentStep]
                            }),
                            /*#__PURE__*/ _jsx(Current, {
                                funnelState: state
                            })
                        ]
                    }, state.currentStep),
                    funnelState: state,
                    isAtStart: state.currentStep === Object.keys(orderedStepComponents)[0],
                    isPending: isPending,
                    onBackClick: ()=>startTransition(()=>{
                            if (formRef.current) {
                                const formData = new FormData(formRef.current);
                                dispatch({
                                    formData,
                                    isBackwards: true
                                });
                            }
                        }),
                    previous: state.transitioningStep && Transitioning && /*#__PURE__*/ _jsxs("div", {
                        className: styles['funnel-embed-step'],
                        children: [
                            /*#__PURE__*/ _jsx(Text, {
                                bold: true,
                                className: styles.headline,
                                size: "l",
                                children: titleMap[state.transitioningStep]
                            }),
                            tooltipContentMap[state.transitioningStep] && /*#__PURE__*/ _jsx(ReasonWhyTooltip, {
                                content: tooltipContentMap[state.transitioningStep]
                            }),
                            /*#__PURE__*/ _jsx(Transitioning, {
                                funnelState: state
                            }, state.transitioningStep)
                        ]
                    }, state.transitioningStep)
                })
            ]
        })
    });
};

//# sourceMappingURL=b2b-funnel-embed.inner.js.map